<h2 mat-dialog-title>{{ 'attestorHistoryDialog.attestorHistory' | transloco }}</h2>
<mat-dialog-content>
    <table mat-table [dataSource]="attestorLogs" multiTemplateDataRows class="mat-elevation-z2">
        <ng-container matColumnDef="added">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.added' | transloco }} </th>
            <td mat-cell *matCellDef="let log"> {{ log.added | localizedDate }} </td>
        </ng-container>

        <ng-container matColumnDef="message">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.message' | transloco }} </th>
            <td mat-cell *matCellDef="let log"> {{ log.message }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>